import { render, staticRenderFns } from "./ProsAndConsInput.vue?vue&type=template&id=366e33c4&"
import script from "./ProsAndConsInput.vue?vue&type=script&lang=js&"
export * from "./ProsAndConsInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports